import { createFileRoute } from '@tanstack/react-router'
import { NotificationsTab } from '@/pages/Settings'

export const Route = createFileRoute('/_authenticated/settings/notifications')({
  component: NotificationsTab,
})
